import { render, staticRenderFns } from "./ContactText.vue?vue&type=template&id=3f24c8fe&"
import script from "./ContactText.vue?vue&type=script&lang=ts&"
export * from "./ContactText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports